import { createElement, memo, useState, useEffect } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './CityList.scss';
function CityList(p) {
    const { cityDataSource, letters } = p;
    // 用来标注字母的dom
    const [loadNum, setLoadNum] = useState(2); // 添加分段加载状态
    useEffect(() => {
        // 添加分段加载逻辑
        let timer = setInterval(() => {
            setLoadNum((loadNum) => {
                if (loadNum > cityDataSource.length) {
                    clearInterval(timer);
                }
                return loadNum + 6;
            });
        }, 300);
        // 清理定时器
        return () => clearInterval(timer);
    }, [cityDataSource]);
    return <View>
      {cityDataSource === null || cityDataSource === void 0 ? void 0 : cityDataSource.slice(0, loadNum).map((item, index) => {
        return <View key={item.label}>
              <Text className="city-list-letter">{item.label}</Text>
              <View className="city-list-divider-container">
                <View className="city-list-short-divider"/>
              </View>
              {item === null || item === void 0 ? void 0 : item.data.map((city, index) => {
            return <View onClick={() => {
                p.emitCity(city);
            }} key={`${city.id}-${index}`}>
                      <Text className="city-list-city-name" key={city.id}>{city.name}</Text>
                    </View>;
        })}
            </View>;
    })}

    </View>;
}
export default memo(CityList);
